var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-notfound--inner"},[_vm._v("\n  this page missing fool!\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }